import Choices from "choices.js";
import passiveSave from "../actions/passiveSave.js";
export default async function manageTags(node) {
  // getting the node of the settings json file within the tephra family
  let JsonNode;
  if (node.children !== null) {
    JsonNode = node.children.find(node => {
      return (node = node.title == "settings.json");
    });
  } else {
    JsonNode = node;
  }

  // get the content of the JSON file
  const getContent = async () => {
    const loadPromise = new Promise(resolve => {
      CodeEditor.Main.loadFile(
        JsonNode,
        "tephra_snippet",
        node.data.path + "/settings.json",
        (node, data) => resolve(data),
        true
      );
    });
    const content = await loadPromise;
    return content;
  };
  let rawContent = await getContent();

  // making sure not to load the modal until the data is parsed
  if ((await rawContent).length) {
    console.log(JSON.parse(rawContent));
    const modal = CodeEditor.UI.modal("dark-theme hyper wide", "tephra_set_tags");
    const HTMLContent = `<h3> Add tags to ${node.title} snippet </h3>
        <div class="choices">
            <input class="m0" type="text" id="tags_input_field">
            <button class="tingle-btn tingle-btn--primary tingle-btn--pull-right" id="tags_input_field_btn">Submit Tags</button>
        </div>
      `;
    modal.setContent(HTMLContent);

    const choices = new Choices(document.getElementById("tags_input_field"), {
      removeItemButton: true,
      duplicateItemsAllowed: false,
      items: JSON.parse(rawContent).tags ?? [],
      editItems: true,
      placeholderValue: "",
      itemSelectText: "Press to select",
      searchEnabled: false,
      searchChoices: false,
      addItemText: value => {
        return `Press Enter to add <b>"${value}"</b>`;
      }
    });
    modal.open();

    document.getElementById("tags_input_field_btn").addEventListener("click", async event => {
      event.preventDefault();
      event.stopPropagation();

      const newTags = document.getElementById("tags_input_field").value;
      const notification = CodeEditor.UI.notif();
      if (!newTags.trim("").length) {
        notification.error({
          message: "A tag can not be an empty string please click to key in your tag and press enter to add it",
          timeout: 2000
        });
        return;
      }

      let settingsJSON = JSON.parse(rawContent);
      let { tags = [] } = settingsJSON;
      // if tags exist but it's not an array, inform the user of this error.
      if (!Array.isArray(settingsJSON.tags) && settingsJSON.tags !== "") {
        alert(`tags in settings.json should be an array type instead of a ${typeof tags} type.`);
        return;
      }

      const newTagsArray = newTags.split(",");
      tags = tags.splice(0, tags.length, ...newTagsArray);
      const UpdatedNode = {
        ...JsonNode.data,
        getContent: JSON.stringify(settingsJSON, null, "\t"),
        content: JSON.stringify(settingsJSON, null, "\t"),
        extension: "json"
      };
      let getSaveStatus = await passiveSave(UpdatedNode, null);
      if (await getSaveStatus) {
        modal.destroy();
        notification({
          message: "Tags added successfuly!",
          timeout: 2000
        });
        choices.destroy();
        return;
      } else {
        console.log("nope");
      }
    });
  }
}
